import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAppointment = (clinicId,date=new Date().toISOString().split('T')[0],docId)=>{
    if(docId === 0 ){
        return axios.get(API_URL+"clinics/"+clinicId+"/appointments?date="+date)
    }else{
        return axios.get(API_URL+"clinics/"+clinicId+"/appointments?date="+date+"&doctorId="+docId)
    }
   
}

const updateAppointmentStatus = (clinicId,appointmentid,apptStatus) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/appointments/"+appointmentid+"?status="+apptStatus)

}

const getAppointmentNotes = (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/appointments/notes")
}
const saveAppointmentNotes = (clinicId, notes)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/appointments/notes", notes)
}
const deleteAppointmentNotes = (clinicId, notesId)=>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/appointments/notes/"+notesId)
}
const appointmentService = {
    getAppointment,
    updateAppointmentStatus,
    getAppointmentNotes,
    saveAppointmentNotes,
    deleteAppointmentNotes
}
export default appointmentService